export default {
    init() {

    },
    finalize() {

        if ($('.recensioni-carousel').length > 0) {
            $('.recensioni-carousel').slick({
                autoplay: false,
                dots: true,
                arrows: false,
                adaptiveHeight: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1
            });
        }

        if ($('.about-storia-carousel').length > 0) {
            $('.about-storia-carousel').slick({
                autoplay: false,
                dots: false,
                arrows: true,
                prevArrow: $('.storia-slide-prev'),
                nextArrow: $('.storia-slide-next'),
                adaptiveHeight: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }).on('beforeChange', function () {
                //TODO
            }).on('afterChange', function () {
                let current_slide_index = $('.slick-slide.slick-current.slick-active').attr('data-slick-index');
                let $dots_list = $('.dot-navigator .dot-anno');
                $dots_list.removeClass('active');
                $dots_list.each(function (i, elem) {
                    if ($(elem).attr('data-index') === current_slide_index) {
                        $(elem).addClass('active');
                    }
                });
            }).slick('slickGoTo', 0);
            $('.dot-navigator .dot-anno').on('click', function () {
                $('.about-storia-carousel').slick('slickGoTo', $(this).attr('data-index'));
            });
        }

        if ($('.page-template-template-store-locator').length > 0) {

            var qs = getParameterByName('city');

            if (qs !== null) {
                console.log(qs);
                $(window).on('load', function () {
                    $('#wpsl-search-input').val(qs).focus();
                    $('#wpsl-search-btn').click();
                });
            }

            $('.btn-outline-primary').on('click', function () {
                if ($(window).width() <= 768) {
                    var href = $(this).attr('href');
                    $('.btn-outline-primary').removeClass('active');
                    $(this).addClass('active');
                    $('.store-locator-tab').removeClass('active');
                    $(href).toggleClass('active');
                }
            });

        }
    },
};

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


// WEBPACK FOOTER //
// ./scripts/routes/page.js